import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import {
  Grid,
  Typography,
  Hidden,
  Box,
} from '@material-ui/core';

import MenuItems from './HeaderMenuItems';

const useStyles = makeStyles((theme) => ({
  hidden: {
    display: 'none',
  },
  link: {
    fontSize: '16px',
  },
  container: {
    padding: 0,
    height: '5.625rem',
  },
  headerContainer: {
    backgroundColor: (customerTheme) => customerTheme?.headerBackgroundColor || '#323232',
    position: 'relative',
    zIndex: 10,
  },
  widthWrapper: {
    padding: '0  3.125rem',

    [theme.breakpoints.down('sm')]: {
      padding: '0 2rem',
    },
  },
  nowrap: {
    flexWrap: 'nowrap',
  },
  titleGrid: {
    overflowY: 'hidden',
    cursor: 'pointer',
    width: 155,
    '@media (max-width: 960px)': {
      width: '100px',
    },
  },
  menuGrid: {
    height: '100%',
    flex: 1,
    paddingRight: '2.3125rem',
    flexWrap: 'nowrap',
  },
}));

const DesktopHeader = ({
  title,
  menuItems,
  hideNav = false,
  hidden,
  children,
  goToLink,
  toggleHoverOff,
  toggleHoverOn,
  hoverKey,
  customerTheme,
}) => {
  const classes = useStyles(customerTheme);
  const topLevelPath = window.location.pathname.split('/')[1];

  return (
    <Box
      className={classNames(classes.container, classes.headerContainer, {
        [classes.hidden]: hidden,
      })}
    >
      <Box className={classes.widthWrapper}>
        <Grid
          container
          alignItems="center"
          justify="space-between"
          className={classNames(classes.container, classes.nowrap)}
        >
          <Hidden smDown>
            <Grid
              item
              onClick={() => goToLink('/')}
              className={classes.titleGrid}
            >
              <Typography>{title}</Typography>
            </Grid>
          </Hidden>
          {!hideNav && (
            <>
              <Grid
                container
                item
                alignItems="center"
                className={classes.menuGrid}
              >
                <MenuItems
                  menuItems={menuItems}
                  topLevelPath={topLevelPath}
                  hoverKey={hoverKey}
                  classes={classes}
                  toggleHoverOn={toggleHoverOn}
                  toggleHoverOff={toggleHoverOff}
                  goToLink={goToLink}
                  customerTheme={customerTheme}
                />
              </Grid>
              {children}
            </>
          )}
        </Grid>
      </Box>
    </Box>
  );
};

DesktopHeader.propTypes = {
  title: PropTypes.string.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  hideNav: PropTypes.bool.isRequired,
  hidden: PropTypes.bool.isRequired,
  children: PropTypes.node,
  goToLink: PropTypes.func.isRequired,
  toggleHoverOff: PropTypes.func.isRequired,
  toggleHoverOn: PropTypes.func.isRequired,
  hoverKey: PropTypes.string,
  customerTheme: PropTypes.shape({
    bannerBackgroundImage: PropTypes.string,
    bannerButtonColor: PropTypes.string,
    bannerTextColor: PropTypes.string,
    commsBanner: PropTypes.string,
    ctaLink: PropTypes.string,
    ctaText: PropTypes.string,
    customDomain: PropTypes.string,
    footerText: PropTypes.string,
    headerBackgroundColor: PropTypes.string,
    headerLinksHoverBackgroundColor: PropTypes.string,
    headerTextColor: PropTypes.string,
    logo: PropTypes.string,
    siteTitleText: PropTypes.string,
    welcomeMessage: PropTypes.string,
    welcomeText: PropTypes.string,
  }),
};

export default DesktopHeader;
